import { EnvironmentProviders, makeEnvironmentProviders, inject, provideAppInitializer } from '@angular/core';
import { firstValueFrom } from 'rxjs';

import { CONFIG_OPTIONS, ConfigOptions } from 'app/shared/tokens';
import { ConfigService } from 'app/shared/services';

export function provideConfigService(options: ConfigOptions): EnvironmentProviders {
    const providers: any[] = [
        { provide: CONFIG_OPTIONS, useValue: options },
        ConfigService
    ];

    // si preload !== false, registramos el initializer
    if (options.preload !== false) {
        providers.push(
            provideAppInitializer(() => {
                const cfg = inject(ConfigService);
                return firstValueFrom(cfg.loadAll());
            })
        );
    }

    return makeEnvironmentProviders(providers);
}
